import { render, staticRenderFns } from "./ReportedCommunities.vue?vue&type=template&id=036ff5e5&scoped=true"
import script from "./ReportedCommunities.vue?vue&type=script&lang=js"
export * from "./ReportedCommunities.vue?vue&type=script&lang=js"
import style0 from "./ReportedCommunities.vue?vue&type=style&index=0&id=036ff5e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ff5e5",
  null
  
)

export default component.exports